import '../misc/slider_pro.js';
export default {
  init() {
    function load_image(id,w = 1,r = 1) {
      var url = '/product-img/'+id+'/?wall='+w+'&roof='+r;
      $.ajax ({
        type: "GET",
        url: url,
        dataType: 'json',
        async: true,
        success: function (res){
          if(res.status==='success') {
            /*
            if($('#product_image .img_holder img').length) {
              $('product_image .img_holder img').attr('src',res.msg);
              console.log('init');
            }
            else {
              $('#product_image .img_holder').html('<img id="configurator" src="'+res.msg+'" height="375"/>');
            }
            */
            $('img#configurator').attr('src',res.msg);
            $('ul.print li').each(function(){
                //var url = $(this).find('a').attr('href');
                var postName = $(this).find('a').attr('data-postname');
                if(typeof postName!=='undefined') {
                  var newUrl = '/doc/'+postName+'-pdf-doc';
                  var para = ($(this).hasClass('print'))? '/?print&' : '/?';
                  newUrl = newUrl + para;
                  newUrl = newUrl+'wall='+w+'&roof='+r;
                  $(this).find('a').attr('href',newUrl);
                }
            }); 

            //wall='+w+'&roof='+r
            //$('#loader_img').fadeOut(300);
          } 
          else {
              $('#product_image .img_holder').append('<span style="background:red; padding:5px 10px;color:#fff">'+res.msg+'</span>');
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.log(jqXHR);
          console.log(textStatus);
          console.log(errorThrown);
        },
      });
    }

    if($('#product_cnt').length) {
        var id = $('#product_cnt').attr('data-product');
        if(id && $('ul#wall').length || $('ul#roof').length) {
            load_image(id); //load_image(id,wall,roof)
            $('ul.configurator li').click(function(){
                
                if($(this).hasClass('current')) return false;
                

                //$('#loader_img').show();
                var roof, wall;
                var type = $(this).parent().attr('id');
                if(type==='wall') {
                    wall = $(this).attr('data-key'); 
                    roof = $('ul#roof').find('li.current').attr('data-key');
                }
                else if(type==='roof') {
                  roof = $(this).attr('data-key'); 
                  wall = $('ul#wall').find('li.current').attr('data-key');
                }
                $('ul#'+type+' li').removeClass('current');
                $(this).addClass('current');
                load_image(id,wall,roof);
                var colorName = $(this).attr('data-original-title');
                if(typeof colorName!=='undefined' && colorName) {
                    $(this).parent().prev().find('h5.color_name').html(colorName).addClass('active');
                }
                else {
                  $(this).parent().prev().find('h5.color_name').html('').removeClass('active');
                }
            });
        }
    }
    $('#customer_gallery').slick({
      centerMode: true,
      centerPadding: '60px',
      slidesToShow: 3,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            arrows: true,
            centerMode: false,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 580,
          settings: {
            arrows: false,
            slidesToShow: 1,
          },
        },
      ],
    });
  },
  finalize() { 

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/products.js